import React from 'react';
import { TextField } from '@mui/material';

export default function ProjectAuthorizerNameField({
  value,
  onChange,
  error,
  disabled = false,
}) {
  return (
    <TextField
      label='Name'
      value={value}
      onChange={onChange}
      fullWidth
      required
      disabled={disabled}
      error={error}
      autoComplete='off'
    />
  );
}
